import { $all, on } from "@olmokit/dom";
import "./index.scss";

/**
 * Component: Signup
 *
 * The component will be initialised simply by calling the function
 * `Signup();` when you need.
 */
export default function Signup() {
  console.log("Signup mounted.");
  
  const btns = $all(".btn-signup");
  
  if (btns) {
    for(let i=0; i < btns.length; i++){
      on(btns[i], "click", () => {
        let pref = btns[i].getAttribute('data-prefill');
        sessionStorage.setItem("signup", pref);
      });
    }
  }

  /**
   * Public API
   *
   * A public API is required only if the component needs to be controlled from
   * outside, that often happens if the component is used asynchronously and it
   * is required if used in a route managed by barba.js.
   */
  return {
    /**
     * Destroy
     *
     * If the component is used asynchronously, especially in a route managed
     * by barba.js you should implement a destroy method where you deregister
     * listeners and eventually stop background js execution of this component.
     * Otherwise you are free to delete this method.
     */
    destroy() {},
  };
}

/**
 * Initialise
 *
 * You can auto initialise the component by simply uncomment the following line.
 * This is the typical usecase of a component used in a "normal" route (not
 * managed by barba.js) as you can be sure that in this scenario the DOM is
 * ready.
 */
// auto init:
// Signup();

// auto init and exports singleton:
// const signup = Signup();
// export default signup;
